import React, { useState, useEffect, useRef } from "react";
import UserListInfo from "../../../utils/UserListInfo";

let UserManagementFilter = (props) => {
    let [isOpen, setIsOpen] = useState(false)
    let ref = useRef(null)

    const handleClickOutSide = (e) => {
        if (!ref.current.contains(e.target)) {
            setIsOpen(false)
        }
    }

    useEffect(() => {
        if (isOpen)
            document.addEventListener('mousedown', handleClickOutSide)
        return () => {
            document.removeEventListener('mousedown', handleClickOutSide)
        }
    }, [isOpen])
    return (
        <div className={isOpen? " user-management-page-search-filter-opened" : "user-management-page-search-filter"} ref={ref} onClick={() => setIsOpen(!isOpen)}>

            <p className="user-management-page-search-filter-text">{UserListInfo.filter[props.current]}</p>
            <div className="user-management-page-search-filter-button" onClick={() => setIsOpen(!isOpen)}></div>
            {isOpen ?
                <div className="user-management-page-search-filter-dropdown" onClick={() => setIsOpen(false)}>
                    {UserListInfo.filter.map((filter, index) => {
                        return (
                            <div className="user-management-page-search-filter-dropdown-box"
                            onClick={() => props.onClickDropdown(index)}
                            key={filter}>
                                <p className="user-management-page-search-filter-dropdown-text">{filter}</p>
                            </div>
                        )
                    })}
                </div> : null}
        </div>
    )
}

export default UserManagementFilter